module.exports = __webpack_public_path__ + "img/messaggio-referenti-alertmsg.7cde3295.png";